import { CardGrade } from '@cta-portal/webapp-common/lib/api/schema';
export var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "asc";
    SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));
export var TokenType;
(function (TokenType) {
    TokenType["CARD"] = "CARD";
    TokenType["PRESALE_PACK"] = "PRESALE_PACK";
    TokenType["PRESALE_TICKET"] = "PRESALE_TICKET";
    TokenType["MINT_PASS"] = "MINT_PASS";
    TokenType["CHEST"] = "CHEST";
    TokenType["SHARD"] = "SHARD";
    TokenType["SOUVENIR_CARD"] = "SOUVENIR_CARD";
    TokenType["ARISE_COIN"] = "ARISE_COIN";
})(TokenType || (TokenType = {}));
